(function () {
  function initFeaturedProduct(root, swatches) {
    var input = root.querySelector('[data-tlp-variant-input]');
    var image = root.querySelector('[data-tlp-product-image]');
    var price = root.querySelector('[data-tlp-product-price]');
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-tlp-variant-swatch]'));
    var description = root.querySelector('[data-tlp-product-description]');
    var descriptionExcerpt = root.querySelector('[data-tlp-product-description-excerpt]');
    var descriptionFull = root.querySelector('[data-tlp-product-description-full]');
    var descriptionToggle = root.querySelector('[data-tlp-description-toggle]');

    function setPrice(button) {
      if (!price) return;

      var amount = button.getAttribute('data-variant-price');
      var currency = button.getAttribute('data-variant-currency');
      if (!amount) return;

      price.textContent = amount;

      if (currency) {
        var sup = document.createElement('sup');
        sup.textContent = currency;
        price.appendChild(sup);
      }
    }

    function setImage(button) {
      if (!image) return;

      var src = button.getAttribute('data-variant-image');
      var alt = button.getAttribute('data-variant-image-alt');
      if (!src) return;

      image.src = src;
      if (alt) {
        image.alt = alt;
      }
    }

    if (description && descriptionToggle && descriptionExcerpt && descriptionFull) {
      descriptionToggle.addEventListener('click', function () {
        var nextExpanded = descriptionToggle.getAttribute('aria-expanded') !== 'true';

        description.classList.toggle('is-expanded', nextExpanded);
        descriptionToggle.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');
        descriptionToggle.textContent = nextExpanded ? 'Show less' : 'Read full description';
        descriptionExcerpt.hidden = nextExpanded;
        descriptionFull.hidden = !nextExpanded;
      });
    }

    buttons.forEach(function (button) {
      var finish = button.getAttribute('data-finish') || '';
      var color = swatches[finish] || swatches[finish.toLowerCase()];
      var hasImage = !!button.querySelector('.tlp-contact-product__swatch-img');

      if (color) {
        button.style.setProperty('--swatch-color', color);
      } else if (!hasImage && finish && finish !== 'Default Title') {
        console.warn('[TLP contact] Missing finish swatch color for:', finish);
      }

      button.addEventListener('click', function () {
        if (button.disabled) return;

        buttons.forEach(function (candidate) {
          candidate.classList.toggle('is-selected', candidate === button);
          candidate.setAttribute('aria-pressed', candidate === button ? 'true' : 'false');
        });

        if (input) {
          input.value = button.getAttribute('data-variant-id');
        }

        setImage(button);
        setPrice(button);
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-tlp-contact-product]').forEach(function (root) {
      var url = root.getAttribute('data-swatch-map');
      if (!url) {
        initFeaturedProduct(root, {});
        return;
      }

      fetch(url)
        .then(function (response) { return response.ok ? response.json() : {}; })
        .then(function (swatches) { initFeaturedProduct(root, swatches || {}); })
        .catch(function () { initFeaturedProduct(root, {}); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
